<template>
  <a-card v-if="pageLoading">
    <a-spin
      tip="Your document is being processed, do not leave this page!"
      :spinning="pageLoading"
    />
  </a-card>
  <a-row :gutter="8" v-else>
    <a-col :xs="{ span: 24 }">
      <a-form :form="form">
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="PP Detail">
              <a-select
                showSearch
                class="m-width-full"
                placeholder="Select PP"
                @change="handlePp"
                option-filter-prop="children"
                :filter-option="filterOption"
                v-decorator="[
                  'id_pp_dtl',
                  {
                    rules: [{ required: true }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in ppDetail"
                  :key="item.id_pp_dtl" :disabled="item.nilai_dtl_pp == '0' ? true:false "
                >
                  <!-- <div class="elipsdiv">
                    <div v-if="!getScreen" class="elipsdiv-mouseover-label1">
                      <h4>{{ item.nama_barang }}</h4>
                      <small>|</small>
                      <small>{{ item.kode_anggaran }}</small>
                    </div>
                    <div v-else class="elipsdiv-mouseover-label1">
                      <h4>{{ item.nama_barang }}</h4>
                    </div>
                    <div class="elipsdiv-mouseover-label2">
                    <small>{{
                      formatCurrency(item.currency,item.nilai_dtl_pp)
                        .replace(",00", "")
                    }}</small>
                    </div>
                  </div> -->
                  <div class="elipsdiv">
                    <div class="elipsdiv-mouseover-label1">
                      {{ item.nama_barang }}
                      <small v-if="!getScreen">| </small>
                      <small v-if="!getScreen">{{ item.kode_anggaran }}</small>
                    </div>
                    <div class="elipsdiv-mouseover-label2">
                      <b style="float: right">
                        {{
                          formatCurrency(
                            "IDR",
                            parseFloat(item.nilai_dtl_pp)
                          ).replace(",00", "")
                        }}
                      </b>
                    </div>
                  </div>
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item label="Detail Name">
              <a-input
                v-decorator="['detail_name', { rules: [{ required: true }] }]"
              ></a-input>
            </a-form-item>
            <a-form-item label="Date Usage">
              <a-date-picker
                placeholder="Select Date"
                :format="getDefaultDateFormat"
                v-decorator="[
                  'tanggal_pemakaian',
                  { rules: [{ required: true }] },
                ]"
              />
            </a-form-item>
            <a-form-item label="Credit">
              <a-input-number
                :min="0"
                class="m-width-full m-text-align-right"
                :formatter="
                  (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                "
                :parser="(value) => value.replace(/\Rp\s?|(,*)/g, '')"
                v-decorator="['kredit', { rules: [{ required: true }], initialValue:0 }]"
              />
            </a-form-item>
            <a-row :gutter="12">
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <a-form-item label="Is Commission?">
                  <a-radio-group
                    v-decorator="[
                      'iscommision',
                      { rules: [{ required: false }], initialValue: '0' },
                    ]"
                    :disabled="EnCommission"
                    button-style="solid"
                    @change="handleOptionCommission"
                  >
                    <a-radio-button value="1"> Yes </a-radio-button>
                    <a-radio-button value="0"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
              <a-col :xs="{ span: 12 }" :lg="{ span: 12 }">
                <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                  <a-form-item label="With Note?" :hidden="true">
                  <a-radio-group
                    v-decorator="[
                      'without_note',
                      { rules: [{ required: false }], initialValue: '0' },
                    ]"
                    button-style="solid"
                  >
                    <a-radio-button value="0"> Yes </a-radio-button>
                    <a-radio-button value="1"> No </a-radio-button>
                  </a-radio-group>
                </a-form-item>
              </a-col>
            </a-row>
            <a-form-item label="Upload Transaction Document">
              <a-upload
                :showUploadList="true"
                :fileList="doctransfiles"
                :beforeUpload="beforedoctransUpload"
                :remove="handledoctransRemove"
                v-decorator="['doctrans', { valuePropName: 'doctransfiles' }]"
              >
                <a-button>
                  <a-icon type="upload" />&nbsp;Select File
                </a-button>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <a-divider class="margin-bottom-small">or</a-divider>
      <div>
        <h4>Upload File Excel</h4>
        <p>
          If you don't have the file upload template yet, please kindly click
          <a-button class="padding-remove" type="link" @click="handleDownload"
            >Download Template</a-button
          >
        </p>
        <a-upload
          accept=".xls, .xlsx"
          :showUploadList="true"
          :fileList="push"
          :beforeUpload="beforeUpload"
          :remove="handleRemove"
          v-decorator="['upload', { valuePropName: 'push' }]"
        >
          <a-button> <a-icon type="upload" />&nbsp;Select your file </a-button>
        </a-upload>
        <a-divider v-if="getScreen"></a-divider>
      </div>
      <a-button
        v-if="getScreen"
        type="primary"
        block
        @click="handleNew"
        :loading="newLoading"
        >Add</a-button
      >
    </a-col>
    <a-col :xs="{ span: 24 }" v-if="getScreen">
      <a-collapse class="margin-top">
        <a-collapse-panel key="1">
          <h4 slot="header" class="margin-remove">Lihat Detail</h4>
          <a-list
            itemLayout="vertical"
            :dataSource="dataList"
            :pagination="pagination"
          >
            <Empty v-if="dataList ? dataList.length <= 0 : dataList" />
            <a-list-item slot="renderItem" slot-scope="item">
              <a-list-item-meta>
                <a-row slot="title" type="flex" justify="space-between">
                  <a href="#">{{ item.deskripsi }}</a>
                </a-row>
                <div slot="description">
                  <ul class="m-list-wrapper">
                    <li class="margin-remove">
                      {{
                        moment(item.tanggal_pemakaian).format(
                          getDefaultDateFormat
                        )
                      }}
                    </li>
                    <li v-if="item.debit !== ''">
                      <h4 class="margin-remove m-text-sub">Debit</h4>
                      <h3 class="margin-remove">
                        {{ formatRupiah(item.debit) }}
                      </h3>
                    </li>
                    <li v-else>
                      <h4 class="margin-remove m-text-sub">Kredit</h4>
                      <h3 class="margin-remove">
                        {{ formatRupiah(item.kredit) }}
                      </h3>
                    </li>
                  </ul>
                </div>
              </a-list-item-meta>
              <a-button-group v-if="getScreen && item.kredit !== ''">
                <a-button type="primary" @click="handleEdit(item)">
                  <a-icon type="edit" />&nbsp;Change
                </a-button>
                <a-button type="danger" @click="handleRemoveDetail(item)">
                  <a-icon type="close" />&nbsp; Delete
                </a-button>
              </a-button-group>
            </a-list-item>
          </a-list>
        </a-collapse-panel>
      </a-collapse>
      <div class="m-price-total" v-if="pageLoading === false">
        <div class="m-display-flex space-between align-middle">
          <h4>Total Kredit</h4>
          <h3>{{ formatRupiah(kredit) }}</h3>
        </div>
      </div>
      <a-checkbox :disabled="dataList.length < 1" @change="handleCheckData"
        >Is Data Completed?</a-checkbox
      >
    </a-col>

    <a-modal
      title="Konfirmasi"
      :visible="confirm"
      @ok="handleOk(type_mode)"
      :confirmLoading="confirmLoading"
      @cancel="handleCancel"
      :maskClosable="false"
    >
      <p>The data that has been added will be overwritten with your new file? Are you sure?</p>
    </a-modal>
    <Modal
      :data="modal.data"
      :reportingList="dataList"
      :ppList="ppDetail"
      :modalEdit="modal.modalEdit"
      :confirmLoading="modal.confirmLoading"
    />
  </a-row>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Modal from "../Modal.vue";
import _ from "lodash";

export default {
  name: "pemakaianKlaimPp",
  components: {
    Modal,
  },
  mixins: [CurrencyFormat],
  props: {
    data: {},
    informasi: {},
    mode: {},
    url: "",
    id_klaim: "",
    dataList: {},
    debit: 0,
    kredit: 0,
    mata_uang: "",
    type_mode: "",
  },
  data() {
    return {
      push: [],
      confirm: false,
      confirmLoading: false,
      newLoading: false,
      pageLoading: true,
      ppDetail: [],
      selectedPp: [],
      pagination: {
        onChange: (page) => {},
        pageSize: 5,
        size: "small",
      },
      initialEdit: {},
      modal: {
        modalEdit: false,
        confirmLoading: false,
        confirm: false,
        data: {
          tanggal_pemakaian: moment().format(),
          deskripsi: "",
          kredit: "",
          id: "",
          id_pp_dtl: "",
          type_mode: "",
        },
      },
      EnCommission: true,
      Viwithout_note: true,
      doctransfiles: [],
    };
  },
  computed: {
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialList() {
      if (this.dataList.length > 0) {
        let kredit = 0;
        let data = this.dataList;
        if (this.dataList.length > 1 || this.dataList !== undefined) {
          data.forEach((item) => {
            kredit = parseInt(kredit) + parseInt(item.kredit);
          });
        }
        return { kredit: kredit };
      } else {
        return { kredit: 0 };
      }
    },
  },
  created() {
    this.fetchPemakaian();
    this.fetchPp();
  },
  beforeCreate() {
    this.form = this.$form.createForm(this);
    this.formEdit = this.$form.createForm(this);
  },
  methods: {
    moment,
    beforeUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      let extension =
        file.name.substr(file.name.lastIndexOf(".")) == ".xls" ||
        file.name.substr(file.name.lastIndexOf(".")) == ".xlsx";
      if (extension) {
        if (FileSize > 2) {
          this.displayMessage("large-file-2mb");
        } else {
          this.push = [file];
          this.form.resetFields();
          return false;
        }
      } else {
        this.displayMessage("error-formatXls");
      }
    },
    done() {
      this.pageLoading = false;
    },
    async fetchPp() {
      await axios({
        method: "get",
        url: this.$serviceUrl + "klaim_cc_pp/pp_detil",
        params: this.mode=='Edit' && this.type_mode!="draft" ? {
          id_pp: this.informasi.id_pp,
        } : {
          id_pp: this.informasi.id_pp,
          id_klaim_draft: this.id_klaim,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.ppDetail = response.data.list_nama_item;
        })
        .catch((err) => {
          alert(err);
          // this.displayMessage("error-getdetil");
        });
    },
    fetchPemakaian() {
      this.pageLoading = true;
      Event.$emit("fetchPemakaian", true);
    },
    handleRemoveDetail(e) {
      Event.$emit("removeDetail", e);
    },
    handleRemove(){
      this.push = [];
    },
    handleOk(e) {
      Event.$emit("handleLoading", true);
      this.ModalText = "The modal will be closed after two seconds";
      this.confirmLoading = true;

      let addData = new FormData();

      addData.append("tlc", this.getAuth.username);
      addData.append("id_klaim", this.id_klaim);
      addData.append("no_pp", this.informasi.no_pp);
      addData.append(
        "tanggal_pelaporan",
        this.informasi.tanggal_pelaporan.format(this.getDefaultDateFormat)
      );
      this.push.forEach((file) => {
        addData.append("file_upload", file);
      });

      this.postUpload(addData);
    },
    handleCancel(e) {
      this.confirm = false;
      this.modal.modalEdit = false;
    },
    handlePp(e) {
      this.selectedPp = this.ppDetail.filter(
        (obj) => obj.id_pp_dtl.toLowerCase().indexOf(e.toLowerCase()) >= 0
      );

      let selectedumDtl = _.filter(this.ppDetail, { id_pp_dtl: e });
      if(selectedumDtl[0] && selectedumDtl[0].is_komisi){
        this.EnCommission = true;
        this.Viwithout_note = false;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "1",
              without_note: "0",
          });
        });
      }else{
        this.EnCommission = false;
        this.Viwithout_note = true;
        this.$nextTick(function () {
          this.form.setFieldsValue({
              iscommision: "0",
              without_note: "0",
          });
        });
      }
    },
    handleNew() {
      Event.$emit("handleLoading", true);
      if (this.push.length > 0) {
        let addData = new FormData();

        addData.append("tlc", this.getAuth.username);
        addData.append("id_klaim", this.id_klaim);
        addData.append("no_pp", this.informasi.no_pp);
        addData.append(
          "tanggal_pelaporan",
          this.informasi.tanggal_pelaporan.format(this.getStandartFormatDate)
        );
        addData.append("iscommision", "0");
        addData.append("without_note", "1");

        this.push.forEach((file) => {
          addData.append("file_upload", file);
        });
        addData.append("id_user_cc", this.informasi.id_user_cc);

        this.newLoading = true;
        this.pageLoading = true;

        this.postUpload(addData);
      } else {
        this.form.validateFields((err, values) => {
          if (err) {
            this.newLoading = false;
            this.pageLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("form-warning");
            return;
          }

          if(moment(values.tanggal_pemakaian).format('YYYY-MM-DD')>moment().format('YYYY-MM-DD')){
            Event.$emit("handleLoading", false);
            this.displayMessageValue("error-other", "Usage date can't exceed today!");
            return;
          }

          if(values.kredit > 0){
            this.handlePp(values.id_pp_dtl);
            if (values.kredit > this.selectedPp[0].nilai_dtl_pp) {
              Event.$emit("handleLoading", false);
              this.displayMessage("over-kredit");
              return;
            }

            const selected = this.selectedPp[0];
            const datalist = this.dataList.filter(function(item) {
              if (
                      item.deskripsi.toLowerCase() === values.detail_name.toLowerCase() &&
                      item.item_nm === selected.item_nm
              ) {
                return true;
              }
            });

            // if (datalist.length > 0) {
            //   this.displayMessage("form-duplicate");
            //   return;
            // } else {
            let addData = new FormData();
            addData.append("tlc", this.getAuth.username);
            addData.append("no_pp", this.informasi.no_pp);
            addData.append("id_klaim", this.id_klaim);
            addData.append("tanggal_pelaporan", this.informasi.tanggal_pelaporan.format(
              this.getStandartFormatDate
            ));
            addData.append("pp_dtl", values.id_pp_dtl);
            addData.append("tanggal_pemakaian", values.tanggal_pemakaian.format(
              this.getStandartFormatDate
            ));
            addData.append("deskripsi", values.detail_name);
            addData.append("kredit", values.kredit);
            addData.append("iscommision", values.iscommision);
            // addData.append("without_note", values.without_note);
            addData.append("without_note", "1");
            if (this.doctransfiles && this.doctransfiles.length > 0) {
              this.doctransfiles.forEach((file) => {
                addData.append("file_upload", file);
              });
            }
            addData.append("id_user_cc", this.informasi.id_user_cc);

              this.newLoading = true;
              Event.$emit("startLoadingTable");
              axios({
                method: "post",
                url: this.url,
                processData: false,
                data: addData,
                auth: {
                  username: this.getAuth.username,
                  password: this.getAuth.password,
                },
                headers: {
                  // "Content-Type": "application/json",
                  "X-API-KEY": this.getAuth.apikey,
                },
              })
                      .then((response) => {
                        this.fetchPp();
                        this.fetchPemakaian();
                        this.displayMessage("success-add");
                        this.newLoading = false;
                        this.pageLoading = false;
                        this.form.resetFields();
                        this.doctransfiles = [];
                        if (this.mode === "Create") {
                          Event.$emit("disableInformasi", true);
                        }
                        Event.$emit("stopLoadingTable");
                        this.selectedPp = [];
                      })
                      .catch((err) => {
                        this.newLoading = false;
                        Event.$emit("handleLoading", false);
                        let response = Object.assign({}, err.response.data);
                        this.displayMessageValue("error-other", response.message);
                        Event.$emit("stopLoadingTable");
                      });
            // }
          }else{
            this.newLoading = false;
            Event.$emit("handleLoading", false);
            this.displayMessage("value-0");
          }


        });
      }
    },
    postUpload(data) {
      let url =
        this.type_mode === "revised"
          ? "klaim_cc_pp/revisi_upload_detil_pemakaian"
          : "klaim_cc_pp/upload_detil_pemakaian";
      axios({
        method: "post",
        url: this.$serviceUrl + url,
        processData: false,
        data: data,
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "Content-Type": "multipart/form-data",
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (this.mode === "Create") {
            this.fetchPp();
            this.fetchPemakaian();
            this.newLoading = false;
            this.confirmLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            this.displayMessage("success-add");
            Event.$emit("disableInformasi", true);
          } else {
            this.fetchPp();
            this.fetchPemakaian();
            this.newLoading = false;
            this.confirmLoading = false;
            this.pageLoading = false;
            this.confirm = false;
            this.displayMessage("success-edit");
            Event.$emit("disableInformasi", true);
          }
          this.push = [];
          Event.$emit("handleLoading", false);
        })
        .catch((err) => {
          this.displayMessage("error-upload");
          this.newLoading = false;
          this.pageLoading = false;
          this.confirm = false;
          this.confirmLoading = false;
          Event.$emit("disableInformasi", true);
          Event.$emit("handleLoading", false);
        });
    },
    handleCheckData(e) {
      Event.$emit("draftStatus", e.target.checked);
    },
    async handleFetchEdit(item) {
      const url =
        this.type_mode == "draft"
          ? "klaim_cc_pp/detil_pemakaian_update"
          : "klaim_cc_pp/revisi_detil_pemakaian_update";
      return await axios({
        method: "get",
        url: this.$serviceUrl + url,
        params: {
          id_dtl_klaim: item.id,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleEdit(item) {
      this.handleFetchEdit(item).then((result) => {
        this.ppDetail = result.data.list_dtl_sppd;
        this.modal.data = {
          tanggal_pemakaian: result.data.tgl,
          deskripsi: result.data.detail,
          kredit: result.data.kredit,
          id: result.data.id_dtl,
          id_pp_dtl: result.data.selected_sppd_dtl,
          type_mode: this.type_mode,
        };

        this.modal.modalEdit = true;
      });

      // this.modal.data = {
      //   tanggal_pemakaian: item.tanggal_pemakaian,
      //   deskripsi: item.deskripsi,
      //   kredit: item.kredit,
      //   id: item.id,
      //   id_sppd_dtl: item.id_sppd_dtl_fk,
      //   type: this.type,
      // };
      // this.modal.modalEdit = true;
      // this.modal.type = this.type;
    },
    handleDownload() {
      axios({
        method: "get",
        url:
          this.$serviceUrl +
          "/main/download_template_klaim_biaya?X-API-KEY=xxx",
        params: {
          id_lk: this.id,
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          window.open(this.$serviceUrl + response.data.url, "_blank");
        })
        .catch((err) => {
          this.displayMessage("error-emptyDocTemplate");
        });
    },
    handleNewItemConfirm(){
      if (this.push.length > 0 && this.dataList.length > 0) {
        this.confirm = true;
      } else {
        this.confirmMessageValue("confirm-add-detil",true);
      }
    },
    filterOption(input, option) {
      //console.log(option)
      return (
        option.componentOptions.children[0].children[0].elm.innerText.toLowerCase().indexOf(input.toLowerCase()) >= 0
      );
    },
    handleOptionCommission(val){
      if(val.target.value=="1"){
        this.Viwithout_note = false;
      }else{
        this.Viwithout_note = true;
      }
      this.$nextTick(function () {
          this.form.setFieldsValue({
              without_note: "0",
          });
        });
    },
    beforedoctransUpload(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 5) {
        this.displayMessage("large-file-5mb");
      } else {
        this.doctransfiles = [file];
        return false;
      }
    },
    handledoctransRemove() {
      this.doctransfiles = [];
    },
  },
  mounted() {
    Event.$on("confirmMessageAddDetil", this.handleNew);
    Event.$on("modalCancel", this.handleCancel);
    Event.$on("fetchPp", this.fetchPp);
  },
  beforeDestroy() {
    Event.$off("confirmMessageAddDetil", this.handleNew);
    Event.$off("modalCancel", this.handleCancel);
    Event.$off("fetchPp", this.fetchPp);
  },
};
</script>

<style lang="less">
.select {
  &-option {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    > div {
      display: flex;
      gap: @padding / 2;
    }
  }
  &-between {
    .ant-select-selection {
      width: 100%;
      display: flex;
      justify-content: space-between;
      float: unset !important;
      &__rendered {
        flex: 1;
        padding-right: @padding;
        display: flex;
        float: unset !important;
      }
      &-selected-value {
        flex: 1;
        float: unset !important;
      }
    }
  }
  .ant-select-selection-selected-value {
    width: 100% !important;
  }
}
</style>
